import React, { useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { getConfiguration, getCustomButtonsUrls } from '../data/utils';
import { getLabel } from '../InitData';
import SettingsButtons from '../SettingsButtons';

function showMenu(section) {
        let show = true;

        switch (section) {
            case null:
            case 'checkbet':
            case 'checksystembets':
            case 'mybets':
            case 'betradar-widget':
                show = false;
                break;
            default:
                show = true;
        }
        
        return show;
}

function isSelected(currentSection, buttonHref) {
    return currentSection === buttonHref ? ' active' : '';
}

function HeaderMenu(props) {
    const conf = getConfiguration();
    const section = props.section;
    const refMenuBar = useRef();
    const customUrl = getCustomButtonsUrls();

    useEffect(() => {

        return () => {
            try {
                document.getElementById('header-buttons-container').removeChild(refMenuBar.current)
            }catch(err) {
                console.log(err);
            }
           
        }
    },[])

    
    if (!showMenu(section)) {
        return null;
    }

    function handleClick(section,e) {
        e.preventDefault();
        e.stopPropagation();
        window.openSection(section);
    }
    
    let menuItems = window.appConfig?.MENU?.items || [];
    if(conf.menu?.items){
        menuItems = menuItems.concat(conf.menu.items)
    }

    const buttons = [
        {id: 'prematch'},
        {id: 'live-suite'},
        {id: 'multi-bet'},
        {id: 'live-match'},
        {id: 'live-multi'},
        {id: 'calendar'},
    ];

    return ReactDOM.createPortal(
        <>
            <div ref={refMenuBar} className="menu-principale-barra w-100">
                <nav className="sottomenu-main">
                    <div className="sottomenu-nav maiuscolo sottomenu-principale show" id="cg-scommesse-submenu">
                        {window.appConfig?.MENU?.show === true &&
                            <ul className="nav nav-tabs barra-menu nero w-100">
                                {buttons.map(b => {
                                    if (b.id === 'prematch') {
                                        const url = customUrl[b.id] || null;
                                        if (url) {
                                            return <li key={b.id}><a id="prematch" className={"pointer" + (isSelected(section, 'top-match'))} href={url} data-href="top-match">{getLabel('menu.prematch', 'Prematch')}</a></li>;
                                        }
                                        return <li key={b.id}><a id="prematch" className={"pointer" + (isSelected(section, 'top-match'))} href="#" data-href="top-match" onClick={(e) => handleClick('top-match',e)}>{ conf.iwh ? 'Home' : getLabel('menu.prematch', 'Prematch')}</a></li>;
                                    }
                                    if (b.id === 'live-suite') {
                                        const url = customUrl[b.id] || null;
                                        if (url) {
                                            return <li key={b.id}><a id="live-suite" className={"pointer" + (isSelected(section, 'live-suite'))} href={url} data-href="live-suite">{getLabel('menu.live_suite', 'Live Suite')}</a></li>;
                                        }
                                        return <li key={b.id}><a id="live-suite" className={"pointer" + (isSelected(section, 'live-suite'))} href="#" data-href="live-suite" onClick={(e) => handleClick('live-suite',e)}>{getLabel('menu.live_suite', 'Live Suite')}</a></li>;
                                    }
                                    if (b.id === 'multi-bet') {
                                        const url = customUrl[b.id] || null;
                                        if (url) {
                                            return <li key={b.id}><a id="multi-bet" className={"pointer" + (isSelected(section, 'multi-bet'))} href={url} data-href="multi-bet">{getLabel('menu.multi_bet', 'Multibet')}</a></li>;
                                        }
                                        return <li key={b.id}><a id="multi-bet" className={"pointer" + (isSelected(section, 'multi-bet'))} href="#" data-href="multi-bet" onClick={(e) => handleClick('multi-bet',e)}>{conf.iwh ? 'Live' : getLabel('menu.multi_bet', 'Multibet')}</a></li>;
                                    }
                                    if (b.id === 'live-match') {
                                        const url = customUrl[b.id] || null;
                                        if (url) {
                                            return <li key={b.id}><a id="live-match" className={"pointer" + (isSelected(section, 'live-match'))} href={url} data-href="live-match">{getLabel('menu.live_match', 'Live Matches')}</a></li>;
                                        }
                                        return <li key={b.id}><a id="live-match" className={"pointer" + (isSelected(section, 'live-match'))} href="#" data-href="live-match" onClick={(e) => handleClick('live-match',e)}>{getLabel('menu.live_match', 'Live Matches')}</a></li>
                                    }
                                    if (b.id === 'live-multi') {
                                        const url = customUrl[b.id] || null;
                                        if (url) {
                                            return <li key={b.id}><a id="live-multi" className={"pointer" + (isSelected(section, 'multi-live'))} href={url} data-href="multi-live">{getLabel('menu.live_multi', 'Multilive')}</a></li>;
                                        }
                                        return <li key={b.id}><a id="live-multi" className={"pointer" + (isSelected(section, 'multi-live'))} href="#" data-href="multi-live" onClick={(e) => handleClick('multi-live',e)}>{getLabel('menu.live_multi', 'Multilive')}</a></li>;
                                    }
                                    if (b.id === 'calendar') {
                                        const url = customUrl[b.id] || null;
                                        if (url) {
                                            return <li key={b.id}><a id="calendar" className={"pointer" + (isSelected(section, 'calendar'))} href={url} data-href="calendar">{getLabel('menu.calendar', 'Calendar')}</a></li>;
                                        }
                                        return <li key={b.id}><a id="calendar" className={"pointer" + (isSelected(section, 'calendar'))} href="#" data-href="calendar" onClick={(e) => handleClick('calendar',e)}>{getLabel('menu.calendar', 'Calendar')}</a></li>;
                                    }
                                    return null;
                                })}
                                {menuItems?.map(b => {
                                    const attrs = Object.entries(b.attrs).map(([key, value]) => `${key=='anchor'?'href':key}="${typeof value === 'string' ? value.replaceAll('"', '\'') : key == 'anchor'?value['href']:''}"`);
                                    const html = `<a class="pointer" ${attrs.join(' ')}>${b.label}</a>`;
                                    return (
                                        <li dangerouslySetInnerHTML={{__html: html}} />
                                    );
                                })}
                            </ul>
                        }
                        <SettingsButtons />
                    </div>
                </nav>
            </div>
        </>
    , document.getElementById('header-buttons-container'));
}

const HeaderMenuMemo = React.memo(HeaderMenu, (prevProps, nextProps) => {
    return prevProps.section === nextProps.section;
});

export default HeaderMenuMemo;
